
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_55fkh_ddgda_142",
  "textarea-readonly": "awsui_textarea-readonly_55fkh_ddgda_184",
  "disabled": "awsui_disabled_55fkh_ddgda_189",
  "textarea-invalid": "awsui_textarea-invalid_55fkh_ddgda_197",
  "textarea-warning": "awsui_textarea-warning_55fkh_ddgda_222",
  "textarea": "awsui_textarea_55fkh_ddgda_184",
  "invalid": "awsui_invalid_55fkh_ddgda_325",
  "warning": "awsui_warning_55fkh_ddgda_325",
  "textarea-wrapper": "awsui_textarea-wrapper_55fkh_ddgda_344",
  "button": "awsui_button_55fkh_ddgda_348",
  "action-button": "awsui_action-button_55fkh_ddgda_353",
  "secondary-content": "awsui_secondary-content_55fkh_ddgda_378",
  "with-paddings": "awsui_with-paddings_55fkh_ddgda_416",
  "secondary-actions": "awsui_secondary-actions_55fkh_ddgda_426"
};
  